<dynamicField *ngFor="let field of fields;" [field]="field" [group]="group" [appearance]="appearance"></dynamicField>